import {diagnosticSessionId} from "./diagnostics-client.js";
import type { ApiErrorPayload } from "./types";

export class ApiError extends Error {
  status: number;
  payload: ApiErrorPayload;

  constructor(status: number, payload: ApiErrorPayload) {
    super(payload.error || "The request could not be completed.");
    this.name = "ApiError";
    this.status = status;
    this.payload = payload;
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const isFormData = typeof FormData !== "undefined" && init.body instanceof FormData;
  const response = await fetch(path, {
    credentials: "same-origin",
    ...init,
    headers: {
      "x-pli-diagnostic-session":diagnosticSessionId(),
      ...(init.body && !isFormData ? { "content-type": "application/json" } : {}),
      ...init.headers
    }
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401 && payload.loginUrl && !location.pathname.startsWith("/login")) {
      const returnTo = `${location.pathname}${location.search}`;
      location.assign(`/login?returnTo=${encodeURIComponent(returnTo)}`);
      return new Promise<T>(() => undefined);
    }
    throw new ApiError(response.status, payload);
  }
  return payload as T;
}

export const postJson = <T>(path: string, body: unknown) =>
  api<T>(path, { method: "POST", body: JSON.stringify(body) });

export const putJson = <T>(path: string, body: unknown) =>
  api<T>(path, { method: "PUT", body: JSON.stringify(body) });
